import { FeeType } from 'types/graphql'

import { OrgSlugs } from 'src/constants'

const externalCardReaderSlugs = [
  OrgSlugs.Decatur,
  OrgSlugs.Gonzales,
  OrgSlugs.Groves,
  OrgSlugs.King,
  OrgSlugs.Lewiston,
  OrgSlugs.Paradise,
  OrgSlugs.Perinton,
  OrgSlugs.Piqua,
  OrgSlugs.StGeorge,
  OrgSlugs.Winfield,
]

const hideCashSlugs = [OrgSlugs.StGeorge]

export const isExternalCardReaderSupported = (slug: OrgSlugs): boolean => {
  return externalCardReaderSlugs.includes(slug)
}

export const isCashSupported = (slug: OrgSlugs): boolean => {
  return !hideCashSlugs.includes(slug)
}

export const LateFeeTypes: FeeType[] = ['Late'] as const
